import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PlatTopMenuComponent } from './platTopMenu.component';
import { MatButtonModule, MatIconModule } from '@angular/material';

@NgModule({
	imports: [CommonModule, MatButtonModule, MatIconModule],
	declarations: [PlatTopMenuComponent],
	exports: [PlatTopMenuComponent],
})
export class PlatTopMenuModule {}



// WEBPACK FOOTER //
// ./src/app/layout/components/platTopMenu/platTopMenu.module.ts